import { Input as InputAntd } from 'antd';
import styled from 'styled-components';

export const FiltroInput = styled(InputAntd)`
  width: 188px;
  margin-bottom: 8px;
  display: block;

  .ant-table-filter-trigger-container {
    position: relative;
  }
`;
